<template>
  <div>
    <v-layout
      wrap
      justify-center
      fill-height
      class="select-page"
      style="position: relative; margin-bottom: 35px"
      :class="{ 'no-bot': !botlist || botlist.length == 0 }"
    >
      <template v-for="bot in filterBots">
        <AccountItem :key="'bot_' + bot.pageid" :bot="bot"></AccountItem>
      </template>

      <v-flex
        v-if="isFacebook"
        xs6
        sm4
        md3
        lg2
        class="page pa-3"
        style="cursor: pointer"
        @click="$emit('onAddBot')"
      >
        <v-responsive aspect-ratio="1:1">
          <vue-simple-svg
            :filepath="'/static/img/assets/_global/page-plus.svg'"
            style="min-width: 100%"
            height="auto"
            fill="black"
            class="page-image"
          />
        </v-responsive>

        <div class="page-name text-xs-center black--text mt-2 mb-2">
          {{ $t('Add') }}
        </div>
      </v-flex>
    </v-layout>
    <v-btn
      v-if="botlist && botlist.length >= itemPerPage * page"
      :loading="loading"
      :disabled="loading"
      x-large
      block
      outline
      color="black"
      @click="getMore"
      >MORE</v-btn
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountItem from './AccountItem.vue'
export default {
  components: {
    AccountItem
  },
  props: ['itemPerPage'],
  data() {
    return {
      loading: false,
      offset: 0,
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      isFacebook: 'isFacebook',
      botlist: 'botlist'
    }),
    filterBots() {
      return this.botlist.slice(0, this.page * this.itemPerPage)
    }
  },
  methods: {
    getMore() {
      this.page++
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/AccountForAdmin.vue